import React, {FC, useEffect, useState} from "react";
import {CommonInput, CommonLabel, FlexBox, INPUT_TYPES, useBreakpoint, useIsMobile} from "@brg/ui";
import {ProjectEditPageGridInput} from "../../../../_deziiign/books/pages/BookEdit/styles";
import {JustTable} from "../../../../_competition/components/style";
import SortableList, {SortableItem, SortableKnob} from "react-easy-sort";
import {DefaultButton, TableSortWrapper, TeamEditLabel} from "../styles";
import {DottedIcon} from "../../../icons/DottedIcon";
import {Input} from "@brg/input";
import EditIcon24 from "../../../icons/EditIcon24";
import {BasketIcon} from "../../projectEdit/BasketIcon";
import {LayoutConst} from "../../../../core";
import {useTranslation} from "react-i18next";
import { ReactComponent as PlusSvg } from "../../projectEdit/close.svg";
import {useGetDisciplinesList} from "../../../hooks/api/LMS/useGetDisciplinesList";
import {ProjectEditPageGridRow} from "../../projectEdit/styles";
import { arrayMoveImmutable } from 'shared/utils/arrayMove';
import {API, Endpoints} from "@brg/api";
import {createEmptyLangObject} from "../../../components/__ADDONS__/__SAFEAPI__/Empty";
import {IDiscipline} from "../../../constants/courses/IDiscipline";

export const Disciplines: FC<{ teamId?: string, onModalStateChange: any }> = ({ teamId, onModalStateChange }) => {

    const isS = useBreakpoint(LayoutConst.screen.s - 1);
    const isMobile = useIsMobile();
    const isSmallMob = useBreakpoint(LayoutConst.screen.xsm);
    const { t } = useTranslation();
    const { disciplines: disciplinesRaw } = useGetDisciplinesList(teamId)
    const [disciplines, setDisciplines] = useState<IDiscipline<'Local'>[]>([])

    useEffect(() => {
        setDisciplines(disciplinesRaw)
    }, [disciplinesRaw])

    const onSortEnd = (oldIndex: number, newIndex: number) => {
        const newDisciplines = arrayMoveImmutable(disciplines, oldIndex, newIndex)
        setDisciplines(newDisciplines);

        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/UpdateDisciplinePositions')
            .body(newDisciplines?.map((i: any) => i?.id || "") || [])
            .post()
            .release()
            .then((res: any) => res)
    }

    const onDelete = (index: any) => {
        const confirm = window.confirm(t('confirmation.discipline_delete'))
        if (!confirm) return;

        const temp = [...disciplines];
        temp.splice(index, 1);
        setDisciplines(temp);

        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/DeleteDiscipline')
            .addQuery('id', disciplines[index]?.id || "")
            .post()
            .release()
            .then((res: any) => res)
    }

    const onEdit = (item: any) => {

        onModalStateChange(true, { mode: "discipline", item: item })
    }

    const onCreate = () => {
        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/AddDiscipline')
            .body({
                teamId,
                name: createEmptyLangObject('', ['En', 'Ru']),
                color: '#006FFF'
            })
            .post()
            .release()
            .then((res: any) => {
                // @ts-ignore
                setDisciplines([...disciplines, res])
                onModalStateChange(true, { mode: "discipline", item: res })
            })

    }

    return (
        <ProjectEditPageGridRow align="flex-start" alignMobile="flex-start" style={{marginTop: isS? 24 : 40}} isTeamEdit >
            <CommonLabel 
                label={t('teams.adminPage.fields.disciplines')}
            />
        <FlexBox direction="column" directionMobile="column" widthMobile={'100%'}>
            <ProjectEditPageGridInput  isTeamEdit direction={!!disciplines?.length ? 'column' : 'row'} style={{flexDirection: isMobile ? 'column' : 'inherit'}}>
                {!!disciplines?.length && (
                    <JustTable isTeamEdit>
                        <thead>
                        <tr>
                            <th style={{width: '45%', paddingTop: 0 }}>{t('teams.adminPage.additionalFields.td_name')}</th>
                            <th style={{width: '22%', whiteSpace: 'nowrap', textAlign: 'center', paddingTop: 0 }}></th>
                            {!isS && (
                                <th style={{width: isS ? 0 : '30%', paddingTop: 0}}></th>
                            )}
                        </tr>
                        </thead>
                        <SortableList as={'tbody'} onSortEnd={onSortEnd}>
                            {disciplines.map((discipline: any, index: number) => {
                                //@ts-ignore
                                return (
                                    <SortableItem key={"team-tab-sortable_" + index}>
                                    <tr>
                                        <td style={{ width: isMobile ? '100%' :'auto', padding: isMobile ? '8px 12px 8px 0px' : 'inherit' }}>
                                            <TableSortWrapper direction={'row'} directionMobile="row" align={'center'}>
                                                <SortableKnob>
                                                    <div style={{cursor: 'grab', backgroundColor: 'transparent' }}>
                                                        <DottedIcon />
                                                    </div>
                                                </SortableKnob>
                                                <CommonInput 
                                                    type={INPUT_TYPES.text}
                                                    disable={true}
                                                    value={discipline?.name}
                                                    onChange={() => null}
                                                />
                                            </TableSortWrapper>
                                        </td>
                                        <td style={{ width: isS ? '56px' : '336px' }}>
                                            <FlexBox direction={'row'} directionMobile="row" gx={isS ? 0 : 24} gxMobile={isS ? 0 : 24} widthMobile={'100%'} justifyMobile={isS ? 'end' : 'start'}>
                                                {isS ? (
                                                    <EditIcon24 onClick={() => onEdit(discipline)}/>
                                                ) : (
                                                    <DefaultButton wh={181} whMob={157}  style={{ marginBottom: 5 }} onClick={() => onEdit(discipline)}>
                                                        {t('teams.adminPage.buttons.edit')}
                                                    </DefaultButton>
                                                )}
                                                {isS ? (
                                                    <FlexBox offsetLeftMobile={8}>
                                                        <BasketIcon fill={'#838382'} onClick={() => onDelete(index)}/>
                                                    </FlexBox>
                                                ) : (
                                                    <DefaultButton wh={131} whMob={107} onClick={() => onDelete(index)}>{t('teams.adminPage.buttons.delete')}</DefaultButton>
                                                )}

                                            </FlexBox>
                                        </td>
                                    </tr>
                                    </SortableItem>
                                );
                            })}
                        </SortableList>
                    </JustTable>
                )}
                <FlexBox style={{ marginTop: !disciplines?.length ? 0 : isSmallMob ? 10 : 24}}>
                    <DefaultButton wh={195} whMob={195} onClick={() => {
                        onCreate();
                    }}>
                        <PlusSvg />
                        {t('teams.adminPage.buttons.create')}
                    </DefaultButton>
                </FlexBox>
            </ProjectEditPageGridInput>
        </FlexBox>
        </ProjectEditPageGridRow>
    )
}import React, {FC, useEffect, useState} from "react";
import {CommonInput, CommonLabel, FlexBox, INPUT_TYPES, useBreakpoint, useIsMobile} from "@brg/ui";
import {ProjectEditPageGridInput} from "../../../../_deziiign/books/pages/BookEdit/styles";
import {JustTable} from "../../../../_competition/components/style";
import SortableList, {SortableItem, SortableKnob} from "react-easy-sort";
import {DefaultButton, TableSortWrapper, TeamEditLabel} from "../styles";
import {DottedIcon} from "../../../icons/DottedIcon";
import {Input} from "@brg/input";
import EditIcon24 from "../../../icons/EditIcon24";
import {BasketIcon} from "../../projectEdit/BasketIcon";
import {LayoutConst} from "../../../../core";
import {useTranslation} from "react-i18next";
import { ReactComponent as PlusSvg } from "../../projectEdit/close.svg";
import {useGetDisciplinesList} from "../../../hooks/api/LMS/useGetDisciplinesList";
import {ProjectEditPageGridRow} from "../../projectEdit/styles";
import { arrayMoveImmutable } from 'shared/utils/arrayMove';
import {API, Endpoints} from "@brg/api";
import {createEmptyLangObject} from "../../../components/__ADDONS__/__SAFEAPI__/Empty";
import {IDiscipline} from "../../../constants/courses/IDiscipline";

export const Disciplines: FC<{ teamId?: string, onModalStateChange: any }> = ({ teamId, onModalStateChange }) => {

    const isS = useBreakpoint(LayoutConst.screen.s - 1);
    const isMobile = useIsMobile();
    const isSmallMob = useBreakpoint(LayoutConst.screen.xsm);
    const { t } = useTranslation();
    const { disciplines: disciplinesRaw } = useGetDisciplinesList(teamId)
    const [disciplines, setDisciplines] = useState<IDiscipline<'Local'>[]>([])

    useEffect(() => {
        setDisciplines(disciplinesRaw)
    }, [disciplinesRaw])

    const onSortEnd = (oldIndex: number, newIndex: number) => {
        const newDisciplines = arrayMoveImmutable(disciplines, oldIndex, newIndex)
        setDisciplines(newDisciplines);

        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/UpdateDisciplinePositions')
            .body(newDisciplines?.map((i: any) => i?.id || "") || [])
            .post()
            .release()
            .then((res: any) => res)
    }

    const onDelete = (index: any) => {
        const confirm = window.confirm(t('confirmation.discipline_delete'))
        if (!confirm) return;

        const temp = [...disciplines];
        temp.splice(index, 1);
        setDisciplines(temp);

        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/DeleteDiscipline')
            .addQuery('id', disciplines[index]?.id || "")
            .post()
            .release()
            .then((res: any) => res)
    }

    const onEdit = (item: any) => {

        onModalStateChange(true, { mode: "discipline", item: item })
    }

    const onCreate = () => {
        API.request()
            .endpoint(Endpoints.geoGateway)
            .url('/api/LMS/AddDiscipline')
            .body({
                teamId,
                name: createEmptyLangObject('', ['En', 'Ru']),
                color: '#006FFF'
            })
            .post()
            .release()
            .then((res: any) => {
                // @ts-ignore
                setDisciplines([...disciplines, res])
                onModalStateChange(true, { mode: "discipline", item: res })
            })

    }

    return (
        <ProjectEditPageGridRow align="flex-start" alignMobile="flex-start" style={{marginTop: isS? 24 : 40}} isTeamEdit >
            <CommonLabel 
                label={t('teams.adminPage.fields.disciplines')}
            />
        <FlexBox direction="column" directionMobile="column" widthMobile={'100%'}>
            <ProjectEditPageGridInput  isTeamEdit direction={!!disciplines?.length ? 'column' : 'row'} style={{flexDirection: isMobile ? 'column' : 'inherit'}}>
                {!!disciplines?.length && (
                    <JustTable isTeamEdit>
                        <thead>
                        <tr>
                            <th style={{width: '45%', paddingTop: 0 }}>{t('teams.adminPage.additionalFields.td_name')}</th>
                            <th style={{width: '22%', whiteSpace: 'nowrap', textAlign: 'center', paddingTop: 0 }}></th>
                            {!isS && (
                                <th style={{width: isS ? 0 : '30%', paddingTop: 0}}></th>
                            )}
                        </tr>
                        </thead>
                        <SortableList as={'tbody'} onSortEnd={onSortEnd}>
                            {disciplines.map((discipline: any, index: number) => {
                                //@ts-ignore
                                return (
                                    <SortableItem key={"team-tab-sortable_" + index}>
                                    <tr>
                                        <td style={{ width: isMobile ? '100%' :'auto', padding: isMobile ? '8px 12px 8px 0px' : 'inherit' }}>
                                            <TableSortWrapper direction={'row'} directionMobile="row" align={'center'}>
                                                <SortableKnob>
                                                    <div style={{cursor: 'grab', backgroundColor: 'transparent' }}>
                                                        <DottedIcon />
                                                    </div>
                                                </SortableKnob>
                                                <CommonInput 
                                                    type={INPUT_TYPES.text}
                                                    disable={true}
                                                    value={discipline?.name}
                                                    onChange={() => null}
                                                />
                                            </TableSortWrapper>
                                        </td>
                                        <td style={{ width: isS ? '56px' : '336px' }}>
                                            <FlexBox direction={'row'} directionMobile="row" gx={isS ? 0 : 24} gxMobile={isS ? 0 : 24} widthMobile={'100%'} justifyMobile={isS ? 'end' : 'start'}>
                                                {isS ? (
                                                    <EditIcon24 onClick={() => onEdit(discipline)}/>
                                                ) : (
                                                    <DefaultButton wh={181} whMob={157}  style={{ marginBottom: 5 }} onClick={() => onEdit(discipline)}>
                                                        {t('teams.adminPage.buttons.edit')}
                                                    </DefaultButton>
                                                )}
                                                {isS ? (
                                                    <FlexBox offsetLeftMobile={8}>
                                                        <BasketIcon fill={'#838382'} onClick={() => onDelete(index)}/>
                                                    </FlexBox>
                                                ) : (
                                                    <DefaultButton wh={131} whMob={107} onClick={() => onDelete(index)}>{t('teams.adminPage.buttons.delete')}</DefaultButton>
                                                )}

                                            </FlexBox>
                                        </td>
                                    </tr>
                                    </SortableItem>
                                );
                            })}
                        </SortableList>
                    </JustTable>
                )}
                <FlexBox style={{ marginTop: !disciplines?.length ? 0 : isSmallMob ? 10 : 24}}>
                    <DefaultButton wh={195} whMob={195} onClick={() => {
                        onCreate();
                    }}>
                        <PlusSvg />
                        {t('teams.adminPage.buttons.create')}
                    </DefaultButton>
                </FlexBox>
            </ProjectEditPageGridInput>
        </FlexBox>
        </ProjectEditPageGridRow>
    )
}